import { useRef, useState } from "react";
import { StringParam, useQueryParam } from "use-query-params";

export default function useKeywordsSearch() {
  const debounceTimeoutIdRef = useRef<number>();
  const [keywords, setKeywords] = useQueryParam("keywords", StringParam);
  const [keywordsInputValue, setKeywordsInputValue] = useState(keywords);

  function updateKeywordsInputValue(newValue: string) {
    setKeywordsInputValue(newValue);

    window.clearTimeout(debounceTimeoutIdRef.current);

    debounceTimeoutIdRef.current = window.setTimeout(() => {
      setKeywords(newValue || undefined);
    }, 300);
  }

  function clearKeywords() {
    setKeywords(undefined);
    setKeywordsInputValue("");
  }

  return {
    keywords,
    keywordsInputValue,
    updateKeywordsInputValue,
    clearKeywords,
  };
}
